import { NormalizedNumber } from '@sparkdotfi/common-universal'
import { MoveRightIcon } from 'lucide-react'

import { Token } from '@/domain/types/Token'
import { TokenAmount } from '@/ui/molecules/token-amount/TokenAmount'

export interface TransactionOverviewTokenAmountChangeProps {
  token: Token
  currentAmount: NormalizedNumber
  updatedAmount?: NormalizedNumber
}

export function TransactionOverviewTokenAmountChange({
  token,
  currentAmount,
  updatedAmount,
}: TransactionOverviewTokenAmountChangeProps) {
  return (
    <div className="flex gap-2.5">
      <TokenAmount token={token} amount={currentAmount} />
      {updatedAmount && (
        <>
          <MoveRightIcon className="icon-size-xxs icon-secondary mt-[3px]" />
          <TokenAmount token={token} amount={updatedAmount} />
        </>
      )}
    </div>
  )
}
